import Api from "./Api";
import axios from "axios";

const headers = {
  "Content-Type": "application/json",
  Accept: "application/json",
};

export default {
  getChildSettings() {
    return Api().get(`Setting/child`);
  },

  sendInstructions(data) {
    return Api().post(`send-rfid-instructions`, data);
  },

  getOnlineKiosks() {
    return Api().get(`kiosks/online`);
  },

  verifyRFIDCode(params) {
    return axios.post(
      `${process.env.VUE_APP_BASE_URL_PASSPORT}/api/verify-rfid-code`,
      params,
      {
        headers: headers,
      }
    );
  },
  getUpdatedEventData(resource_id) {
    return Api().get(`resources/resource_info/${resource_id}`);
  },
};
